export type AppTheme = "light" | "dark";

const THEME_STORAGE_KEY = "easyfollow_theme";

export function getStoredTheme(): AppTheme {
  return "dark";
}

export function applyTheme(_theme: AppTheme = "dark") {
  window.localStorage.setItem(THEME_STORAGE_KEY, "dark");
  document.documentElement.classList.add("dark");
  document.body.classList.add("dark");
}

export function initializeTheme() {
  applyTheme("dark");
}
